import { fetchWithAuth } from "../utils/fetch/FetchWithAuth";
import { getRuntimeConfig } from "../utils/runtimeConfig";
import { prepareBaseGetListParams } from "../utils/fetch/PrepareBaseGetListParams";

export const ProductService = {
    // Get product list
    getList: (criteria = {}) => {
        const params = prepareBaseGetListParams(criteria);
        params.append('only_active', criteria.showOnlyActive || false);
        const url = `/portal/inventory/product?${params.toString()}`;
        return fetchWithAuth(url, { method: 'GET' });
    },

    // Get product by ID
    get: (id) => {
        const url = `/portal/inventory/product/${id}`;
        return fetchWithAuth(url, { method: 'GET' });
    },

    // Create new product
    create: (productData) => {
        const url = `/portal/inventory/product`;
        return fetchWithAuth(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(productData)
        });
    },

    // Update product
    update: (id, productData) => {
        const url = `/portal/inventory/product/${id}`;
        return fetchWithAuth(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(productData)
        });
    },

    // Delete product
    delete: (id) => {
        const url = `/portal/inventory/product/${id}`;
        return fetchWithAuth(url, { method: 'DELETE' });
    },

    // Activate product
    activate: (id) => {
        const url = `/portal/inventory/product/${id}/activate`;
        return fetchWithAuth(url, { method: 'PUT' });
    },

    // Deactivate product
    deactivate: (deactivateData) => {
        const url = `/portal/inventory/product/deactivate`;
        return fetchWithAuth(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(deactivateData)
        });
    },

    // Get status list
    getStatusList: () => {
        const url = `/portal/inventory/product/statuses`;
        return fetchWithAuth(url, { method: 'GET' });
    },

    // Get unit of measurement list
    getUnitOfMeasurementList: () => {
        const url = `/portal/inventory/product/udm-list`;
        return fetchWithAuth(url, { method: 'GET' });
    },

    // Get VAT code list
    getVatCodeList: () => {
        const url = `/portal/inventory/product/vat-code-list`;
        return fetchWithAuth(url, { method: 'GET' });
    },

    // Get category names
    getCategoryNames: () => {
        const url = `/portal/inventory/product/category-names`;
        return fetchWithAuth(url, { method: 'GET' });
    },

    // Get all products (list-all-products)
    getAllProducts: () => {
        const url = `/portal/inventory/product/list-all-products`;
        return fetchWithAuth(url, { method: 'GET' });
    },

    // Get currency list
    getCurrencyList: () => {
        const url = `/portal/inventory/product/currencies`;
        return fetchWithAuth(url, { method: 'GET' });
    },

    // Get photo URL
    getPhotoUrl: (product) => {
        try {
            const domain = getRuntimeConfig('REACT_APP_BACKEND_URL');
            return (product.ean) ? `${domain}/portal/inventory/product/photo?ean=${product.ean}` : null;   
        } catch (error) {
            return null;
        }
    },

    // Check EAN availability
    checkEanAvailability: (ean) => {        
        const url = `/portal/inventory/product/ean-availability?ean=${ean}`;
        return fetchWithAuth(url, { method: 'GET' });
    },

    // Get planogram no photo products
    getPlanogramProductsWithHasPhoto: (criteria = {}) => {
        const url = `/portal/inventory/product/planogram-with-has-photo`;
        return fetchWithAuth(url, { method: 'GET' });
    },

};
